<mat-spinner [diameter]="diameter" *ngIf="!isNullOrUndefined(process) && process.isRunning === true"></mat-spinner>
<ng-content *ngIf="isNullOrUndefined(process) || process.isRunning === false"></ng-content>
